// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ctaSection":"ThankYouAddressModal__ctaSection__1XSYd","ModalTitle":"ThankYouAddressModal__ModalTitle__2fNhD"};